<template>
    <div v-if="imageUrl" class="visit">
        <div class="image">
            <div
                class="background-image-wrapper"
                :style="{
                    'background-image': 'url(' + `${imageUrl}` + ')',
                }"
            ></div>
        </div>
        <div class="content">
            <h4 class="text-xl text-primary font-semibold">{{ title }}</h4>
            <div class="mt-4">
                <rich-text v-if="description" :text="description" />
            </div>
            <div v-if="linkUrl" class="mt-4">
                <nuxt-link :to="linkUrl"
                    ><button class="btn btn-link btn-arrow-dark">
                        {{ linkText }}
                    </button></nuxt-link
                >
            </div>
        </div>
    </div>
</template>

<script setup>
defineProps({
    title: {
        type: String,
        default: '',
    },
    description: {
        type: String,
        default: '',
    },
    imageUrl: {
        type: String,
        default: '',
    },
    linkUrl: {
        type: String,
        default: '',
    },
    linkText: {
        type: String,
        default: '',
    },
});
</script>

<style lang="scss" scoped>
.visit {
    background-color: $white;
    box-shadow: 0 1px 16px 2px rgba(0, 0, 0, 0.1);
    .image {
        position: relative;
        width: 100%;
        aspect-ratio: 3/2;
    }
    .content {
        padding: 1rem;
    }
}
</style>
